import axios from "axios";

export const detailBillData = async (client_id, formattedDate, icpt = null, nem = null) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/new-bill/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                icpt: icpt,
                nem: nem
            }
        });
        return response;

    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const detailRP4BillData = async (client_id, formattedDate, afa = null, nem = null) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-rp4-bill/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                afa: afa,
                nem: nem
            }
        });
        return response;
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const solarAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/solar-analysis/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const gridAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/esg-grid/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};


export const loadAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/esg-load/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const getTariff = async (client_id) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-tariff/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const getprintbill = async (client_id) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/export-csv/`, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'text/csv'
            },
            params: {
                site_id: client_id,
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};


export const detailSmartMeterBillData = async (client_id, formattedDate, afa = null, nem = null) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/acc-billing/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                afa: afa,
                nem: nem
            }
        });
        return response;
    } catch (err) {
        throw err;
    }
};



// export const detailSmartMeterBillData = async (client_id, formattedDate, afa = null, nem = null) => {
//     try {
//         const token = sessionStorage.getItem('accessToken');
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-billing/`, {
//             headers: { Authorization: `Bearer ${token}` },
//             params: {
//                 site_id: client_id,
//                 date: formattedDate,
//                 afa: afa,
//                 nem: nem
//             }
//         });
//         return response;
//     } catch (err) {
//         throw err; // Re-throw the error to be caught in handleSubmit
//     }
// };

export const SMsolarAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-esg-solar/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const SMgridAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-esg-grid/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const SMloadAnalysisData = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-smart-meter-esg-load/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const past6monthsbill = async (client_id, formattedDate, afa = null, nem = null) => {
    try {
        const token = sessionStorage.getItem('accessToken');

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/past6-months-bill/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                afa: afa,
                nem: nem
            }
        });

        return response;
    } catch (err) {
        throw err;
    }
};

export const storing_values = async (client_id, formattedDate, afa = null, nem = null) => {
    try {
        const token = sessionStorage.getItem("accessToken");

        // Build URL with all query parameters
        const url = new URL(`${process.env.REACT_APP_API_URL}/api/storing_values/`);
        url.searchParams.append('site_id', client_id);
        url.searchParams.append('date', formattedDate);

        if (afa !== null) {
            url.searchParams.append('afa', afa);
        }

        if (nem !== null) {
            url.searchParams.append('nem', nem);
        }

        const response = await axios.post(
            url.toString(),
            {}, // Empty body since everything is in the URL
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const reading_values = async (client_id, formattedDate, afa = null, nem = null, rebate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/reading_rates/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                afa: afa,
                nem: nem,
                rebate: rebate

            }
        });
        return response;
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const ppa_reading = async (client_id, formattedDate,) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ppa_reading/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,

            }
        });
        return response;
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const ppa_storing = async (client_id, formattedDate, enpconr = null, enopconr = null, capr = null, netr = null) => {
    try {
        const token = sessionStorage.getItem("accessToken");

        // Build URL with all query parameters
        const url = new URL(`${process.env.REACT_APP_API_URL}/api/ppa_storing/`);
        url.searchParams.append('site_id', client_id);
        url.searchParams.append('date', formattedDate);

        if (enpconr !== null) {
            url.searchParams.append('enpconr', enpconr);
        }
        if (enopconr !== null) {
            url.searchParams.append('enopconr', enopconr);
        }
        if (capr !== null) {
            url.searchParams.append('capr', capr);
        }

        if (netr !== null) {
            url.searchParams.append('netr', netr);
        }

        const response = await axios.post(
            url.toString(),
            {}, // Empty body since everything is in the URL
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (error) {
        throw error;
    }
};

export const ppa_calculate = async (client_id, formattedDate, enpconr = null, enopconr = null, capr = null, netr = null) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ppa_calculate/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate,
                enpconr: enpconr,
                enopconr: enopconr,
                capr: capr,
                netr: netr

            }
        });
        return response;
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const bill_storing = async (client_id, formattedDate, afa = null, nem = null, rebate = null) => {
    try {
        const token = sessionStorage.getItem("accessToken");

        // Build query params for client_id, date, afa, nem
        const queryParams = new URLSearchParams({
            site_id: client_id,
            date: formattedDate,
            afa: afa,
            nem: nem
        }).toString();

        // Full URL with query string
        const url = `${process.env.REACT_APP_API_URL}/api/bill-storing/?${queryParams}`;

        // JSON body for rebate only
        const payload = { rebate: rebate ?? 0 };

        const response = await axios.post(url, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response;
    } catch (error) {
        console.error("Error calling bill_storing:", error);
        throw error;
    }
};

export const tariff_comparison_analysis = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tariff-comparison-analysis/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};


// GET - fetch units for a full year
export const saving_summary_unit = async (client_id, year) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/saving-summary-unit/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                year: year        // backend expects year, not date
            }
        });
        return response;
    } catch (err) {
        throw err;
    }
};

// POST - save/update unit for a specific month
export const saving_summary_unit_store = async (client_id, month, unit) => {
    try {
        const token = sessionStorage.getItem('accessToken');

        const url = new URL(`${process.env.REACT_APP_API_URL}/api/saving-summary-unit/`);
        url.searchParams.append('site_id', client_id);
        url.searchParams.append('month', month);
        url.searchParams.append('unit', unit);

        const response = await axios.post(
            url.toString(),
            {}, // empty body
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (err) {
        throw err;
    }
};


export const historical_savings_graph = async (client_id, month) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/historical-savings-graph/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                month: month        // backend expects year, not date
            }
        });
        return response;
    } catch (err) {
        throw err;
    }
};


export const monthly_pf = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/monthly-pf/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};

export const monthly_load_factor = async (client_id, formattedDate) => {
    try {
        const token = sessionStorage.getItem('accessToken');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/monthly-load-factor/`, {
            headers: { Authorization: `Bearer ${token}` },
            params: {
                site_id: client_id,
                date: formattedDate
            }
        });
        return response; // Return response to handle it in the component
    } catch (err) {
        throw err; // Re-throw the error to be caught in handleSubmit
    }
};